export const teamParticipantName = (participant) =>
  `${participant?.first_name || ""} ${participant?.last_name || ""}`.trim() ||
  participant?.email ||
  "Team member";

export const getOtherTeamParticipants = (
  thread,
  currentUserId,
  currentPersonalInboxId,
) =>
  (thread?.participants || []).filter(
    (participant) =>
      (currentUserId === null ||
        currentUserId === undefined ||
        String(participant?.user_id) !== String(currentUserId)) &&
      (currentPersonalInboxId === null ||
        currentPersonalInboxId === undefined ||
        String(participant?.personal_inbox_id) !==
          String(currentPersonalInboxId)),
  );

export const isTeamGroup = (thread) =>
  Math.max(
    Array.isArray(thread?.participant_ids) ? thread.participant_ids.length : 0,
    Array.isArray(thread?.participants) ? thread.participants.length : 0,
  ) > 2;

export const getTeamParticipantIds = (thread) => {
  const participantIds = [
    ...(thread?.participant_ids || []),
    ...(thread?.participants || []).map((participant) =>
      typeof participant === "object"
        ? participant.personal_inbox_id
        : participant,
    ),
  ];

  return [
    ...new Set(
      participantIds
        .map(Number)
        .filter((participantId) => Number.isSafeInteger(participantId)),
    ),
  ];
};

export const filterThreadStatusIds = (thread, statusIds, currentInboxId) => {
  const uniqueIds = [
    ...new Set(
      (statusIds || [])
        .map(Number)
        .filter((statusId) => Number.isSafeInteger(statusId)),
    ),
  ].filter((statusId) => statusId !== +currentInboxId);

  if (thread?.conversation_type !== "team") return uniqueIds;

  const participantIds = new Set(getTeamParticipantIds(thread));
  return uniqueIds.filter((statusId) => participantIds.has(statusId));
};

export const getTeamThreadTitle = (
  thread,
  currentUserId,
  currentPersonalInboxId,
) => {
  if (thread?.label?.trim()) return thread.label.trim();

  const names = getOtherTeamParticipants(
    thread,
    currentUserId,
    currentPersonalInboxId,
  ).map(teamParticipantName);
  if (!names.length) return "Team conversation";
  if (names.length <= 3) return names.join(", ");
  return `${names.slice(0, 2).join(", ")} +${names.length - 2}`;
};

export const teamThreadMatchesSearch = (
  thread,
  search,
  currentUserId,
  currentPersonalInboxId,
) => {
  const query = String(search || "").trim().toLowerCase();
  if (!query || thread?.conversation_type !== "team") return false;

  const participantValues = getOtherTeamParticipants(
    thread,
    currentUserId,
    currentPersonalInboxId,
  )
    .flatMap((participant) => [
      teamParticipantName(participant),
      participant?.first_name,
      participant?.last_name,
      participant?.email,
    ])
    .filter(Boolean);

  return [
    thread?.label,
    getTeamThreadTitle(thread, currentUserId, currentPersonalInboxId),
    ...participantValues,
  ]
    .filter(Boolean)
    .some((value) => String(value).toLowerCase().includes(query));
};
